import { render } from "./TemperatureChart.vue?vue&type=template&id=3ad63cdd"
import script from "./TemperatureChart.vue?vue&type=script&lang=js"
export * from "./TemperatureChart.vue?vue&type=script&lang=js"

import "./TemperatureChart.vue?vue&type=style&index=0&id=3ad63cdd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__